import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <main className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center bg-background-100 rounded-2xl">
          <i className="ri-error-warning-line text-4xl text-foreground-300"></i>
        </div>
        <h1 className="text-6xl md:text-8xl font-bold text-foreground-200 mb-4">404</h1>
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-3">
          页面未找到
        </h2>
        <p className="text-sm text-foreground-500 mb-2">
          您访问的页面不存在或已被移除
        </p>
        <p className="text-xs text-foreground-400 font-mono mb-8">{location.pathname}</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 rounded-full font-medium text-sm whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>返回首页
        </Link>
      </div>
    </main>
  );
}